// Consent-gated AdSense loader.
// Only call after the user has explicitly accepted cookies.
// Idempotent — safe to call multiple times.

const ADSENSE_CLIENT = 'ca-pub-6971125408283377';
const ADSENSE_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;

let loaded = false;

export const loadAdsense = (): void => {
  if (loaded) return;
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[src^="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]`)) {
    loaded = true;
    return;
  }
  const s = document.createElement('script');
  s.src = ADSENSE_SRC;
  s.async = true;
  s.crossOrigin = 'anonymous';
  s.setAttribute('data-consent-loaded', 'true');
  document.head.appendChild(s);
  loaded = true;
};

export const hasAdsenseConsent = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return localStorage.getItem('mnl_cookie_consent') === 'accepted';
  } catch {
    return false;
  }
};

/**
 * Call on app boot. If the user already accepted in a previous visit,
 * load the AdSense script immediately. Otherwise do nothing — CookieConsent
 * will trigger loadAdsense() on Accept.
 */
export const initAdsenseIfConsented = (): void => {
  if (hasAdsenseConsent()) loadAdsense();
};